import {Component, OnInit} from '@angular/core';
import {ReviewState} from "../../../../review/models/review-state";
import {MainLayoutService} from "../../../../shared/services/main-layout.service";

@Component({
  selector: 'app-review-created-invitation',
  templateUrl: './review-created-invitation.component.html',
  styleUrls: ['./review-created-invitation.component.scss']
})
export class ReviewCreatedInvitationComponent implements OnInit {
  reviewState: ReviewState = ReviewState.ReadOnly;


  constructor(
    private mainLayoutService: MainLayoutService,
  ) { }

  ngOnInit(): void {
  }
}
